export default __webpack_public_path__ + "static/header-subheader-anatomy-light-fab0d9cc892e023da3bb0b4d9b4142e1f6ca9c28f238e2da3f8bf759d69aa0d7.png";